"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `
  <svg
    viewBox="0 0 24 24"
    width="24"
    height="24"
    stroke="#555559"
    stroke-width="2"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="css-i6dzq1"
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
`;
